// import Vue from 'vue';
// import Router from 'vue-router';
import { GetUserInfo } from '../services/getData';
// import {MessageBox} from 'element-ui';
import store from '@/store/store';
import {CURRENTUSER} from '@/store/types';
// Vue.use(Router);

const router =  new VueRouter({
	mode: 'history',
	routes: [
        {
            path: '/m/upload_work',
            name: 'UploadWork',
            component: (resolve) => require(['@/views/mobile/UploadWork'],resolve),
            meta: {
                title: '上传作品'
            }
        },
		{
			path: '/',
			name: 'Index',
			component: (resolve) => require(['@/views/Index'],resolve),
			meta: {
                requiresAuth: true,
			},
            children: [
                /*
                * 首页
                 */
                {
                    path: '/',
                    name: 'index',
                    component: (resolve) => require(['@/views/index/Index'],resolve),
                    meta: {
                        requiresAuth: true,
                    }
                },
                //用户成长体系
                {
                    path: '/user_system',
                    name: 'UserSystem',
                    component: (resolve) => require(['@/views/index/UserSystem'],resolve),
                },
                //积分兑换
                {
                    path: '/exchange_course',
                    name: 'ExchangeCourse',
                    component: (resolve) => require(['@/views/index/ExchangeCourse'],resolve),
                },
                // 启蒙课
                {
                    path: 'online/enlighten',
                    name: 'EnlightenLesson',
                    component: (resolve) => require(['@/views/requiredLesson/enlightenLesson/EnlightenLesson'],resolve),
                },
                // 艺术编程
                {
                    path: 'online/art',
                    name: 'ArtLesson',
                    component: (resolve) => require(['@/views/requiredLesson/artLesson/ArtLesson'],resolve),
                },
                // 必修课
                {
                    path: 'online/required',
                    name: 'RequiredLesson',
                    component: (resolve) => require(['@/views/requiredLesson/requiredLesson/RequiredLesson'],resolve),
                },
                /*
                * 线下课堂
                 */
                {
                    path: 'offline',
                    name: 'OfflineClass',
                    component: (resolve) => require(['@/views/offlineClass/OfflineClass'],resolve),
                },
                /*
                * 我的作品
                 */
                {
                    path: 'my_works',
                    name: 'works-list',
                    component: (resolve) => require(['@/views/works/List'],resolve),
                    meta: {
                        requiresAuth: true,
                    }
                },
                {
                    path: '/study_ground',
                    name: 'study-ground',
                    redirect: '/study_ground/presentation',
                    component: (resolve) => require(['@/views/studyGround/Index'], resolve),
                    meta: {
                        requiresAuth: true
                    },
                    children: [
                        {
                            path: 'presentation',
                            name: 'Presentation',
                            component: (resolve) => require(['@/views/studyGround/components/presentation/Index'], resolve),
                            meta: {
                                requiresAuth: true
                            },
                        },
                    ]
                },
                /*
                * 作品详情
                 */
                {
                    path: 'works/:id',
                    name: 'works-detail',
                    component: (resolve) => require(['@/views/works/Detail'],resolve),
                    meta: {
                        requiresAuth: true
                    }
                },
                // {
                //     path: 'works/:id',
                //     name: 'works-detail',
                //     component: (resolve) => require(['@/views/works/Detail'],resolve),
                //     meta: {
                //         requiresAuth: true
                //     }
                // },
                /*
               * 我的素材
                */
                {
                    path: '/material',
                    name: 'material',
                    component: (resolve) => require(['@/views/works/Material'],resolve),
                    meta: {
                        requiresAuth: true
                    }
                },
                /*
                * 专题课
                 */
                {
                    path: '/special',
                    name: 'special',
                    component: (resolve) => require(['@/views/specialClass/List'],resolve),
                    meta: {
                        requiresAuth: true
                    }
                },
                /*
                * 试听课
                 */
                {
                    path: '/online/try_listen',
                    name: 'try-listen',
                    component: (resolve) => require(['@/views/tryListenClass/index/Index'],resolve),
                    meta: {
                        requiresAuth: true
                    }
                },
                // 线上课程专题课
                {
                    path: '/online/online_special',
                    name: 'online-special',
                    component: (resolve) => require(['@/views/specialOnlineClass/index/Index'],resolve),
                    meta: {
                        requiresAuth: true
                    }
                },
	            {
		            path: 'noip/topic_list',
		            name: 'TopicList',
		            component:(resolve)=>require(['@/views/noip/TopicList'], resolve),
		            meta:{
			            requiresAuth: true
		            }
	            },
	            {
		            path: 'noip/topic_detail/:id',
		            name: 'TopicDetail',
		            component:(resolve)=>require(['@/views/noip/TopicDetail'], resolve),
		            meta:{
			            requiresAuth: true
		            }
                },
                {
                    path: '/message_notice',
                    name: 'MessageNotice',
                    component:(resolve)=> require(['@/views/messageNotice/MessageNotice'], resolve),
                    meta:{
                        requiresAuth: true
                    },
                },
            ]
        },
        {
            path: '/noip',
            name: 'noip',
            component:(resolve)=> require(['@/views/noip/Index'], resolve),
            meta:{
                requiresAuth: true
            },
            children:[
                // {
                //     path: '/noip/noip_class/:id',
                //     name: 'NoipClass',
                //     component: (resolve)=>require(['@/views/noip/NoipClass'], resolve),
                //     meta:{
                //         requiresAuth: true
                //     }
                // },
                // {
                //     path: '/noip/noip_class_first/:id',
                //     name: 'NoipClassFirst',
                //     component: (resolve)=>require(['@/views/noip/NoipClassFirst'], resolve),
                //     meta:{
                //         requiresAuth: true
                //     }
                // },
                // {
                //     path: '/noip/noip_expand',
                //     name: 'NoipExpand',
                //     component: (resolve)=>require(['@/views/noip/NoipExpand'], resolve),
                //     meta:{
                //         requiresAuth: true
                //     }
                // },
                // {
                //     path: '/noip/noip_test',
                //     name: 'NoipTest',
                //     component: (resolve)=>require(['@/views/noip/NoipTest'], resolve),
                //     meta:{
                //         requiresAuth: true
                //     }
                // },
                // {
                //     path: '/noip/noip_document',
                //     name: 'NoipDocument',
                //     component: (resolve)=>require(['@/views/noip/NoipDocument'], resolve),
                //     meta:{
                //         requiresAuth: true
                //     }
                // },
                {
                    path: '/noip/noip_report',
                    name: 'NoipReport',
                    component: (resolve)=>require(['@/views/noip/component/NoipReport'], resolve),
                    meta:{
                        requiresAuth: true
                    }
                },
                {
                    path: '/noip/noip_report_detail/:id',
                    name: 'NoipReportDetail',
                    component: (resolve)=>require(['@/views/noip/component/NoipReportDetail'], resolve),
                    meta:{
                        requiresAuth: true
                    }
                },

                {
                    path: '/noip/noip_oj',
                    name: 'NoipOj',
                    component: (resolve)=>require(['@/views/noip/NoipOj'], resolve),
                    meta:{
                        requiresAuth: true
                    }
                },
                {
                    path: '/noip/noip_oj_class/:id',
                    name: 'NoipOjClass',
                    component: (resolve)=>require(['@/views/noip/component/NoipOjClass'], resolve),
                    meta:{
                        requiresAuth: true
                    }
                },
            ],

        },
        {
            path: '/noip/allow_view',
            name: 'NoipAllow',
            component:(resolve)=>require(['@/views/noip/NoipAllow'], resolve),
            meta:{
                requiresAuth: true
            }
        },
        {
            path: '/art/allow_view',
            name: 'ArtAllow',
            component:(resolve)=>require(['@/views/art/ArtAllow'], resolve),
            meta:{
                requiresAuth: true
            }
        },
		{
			path: '/python',
			name: 'python',
			component:(resolve)=> require(['@/views/python/Index'], resolve),
			meta:{
				requiresAuth: true
			},
			children:[
				// {
				// 	path: 'class/:id',
				// 	name: 'class',
				// 	component:(resolve)=>require(['@/views/python/PythonClass'], resolve),
				// 	meta:{
				// 		requiresAuth: true
				// 	}
				// },
                // {
                //     path: 'audio/:id',
                //     name: 'audio',
                //     component:(resolve)=>require(['@/views/python/PythonAudio'], resolve),
                //     meta:{
                //         requiresAuth: true
                //     }
                // },
				// {
				// 	path: 'test',
				// 	name: 'test',
				// 	component:(resolve)=> require(['@/views/python/PythonTest'], resolve),
				// 	meta:{
				// 		requiresAuth: true
				// 	}
                // },
                // {
                //     path: 'document',
                //     name: 'document',
                //     component: (resolve)=> require(['@/views/python/PythonDocument'], resolve),
                //     meta:{
                //         requiresAuth: true
                //     }
                // },
                // {
                //     path: 'expand',
                //     name: 'expand',
                //     component: (resolve)=> require(['@/views/python/PythonExpand'], resolve),
                //     meta:{
                //         requiresAuth: true
                //     }
                // },
				{
					path: 'report',
					name: 'report',
					component:(resolve)=>require(['@/views/python/component/PythonReport'], resolve),
					meta:{
						requiresAuth: true
					}
				},
				{
					path: 'report_detail/:id',
					name: 'reportDetail',
					component:(resolve)=>require(['@/views/python/component/PythonReportDetail'], resolve),
					meta:{
						requiresAuth: true
					}
				},

				{
		            path: 'create',
		            name: 'create',
		            component: (resolve)=> require(['@/views/python/component/PythonCreate'], resolve),
		            meta:{
			            requiresAuth: true
		            }
	            },
                {
                    path: 'create_first',
                    name: 'createFirst',
                    component: (resolve)=> require(['@/views/python/component/PythonCreateFirst'], resolve),
                    meta:{
                        requiresAuth: true
                    }
                },

                {
                    path: 'technical',
                    name: 'technical',
                    component: (resolve)=> require(['@/views/python/component/PythonTechnicalDocument'], resolve),
                    meta:{
                        requiresAuth: true
                    }
                }
			]
        },
        {
            path: '/art',
            name: 'Art',
            component: (resolve)=>require(['@/views/art/Index'], resolve),
            meta: {
                requiresAuth: true
            },
            children:[]
        },
        // 进入哈尼克斯圆桌班级
        // 查看学员作业列表
        // 消息提醒页
        // {
        //     path: '/message_notice',
		// 	name: 'MessageNotice',
		// 	component:(resolve)=> require(['@/views/messageNotice/MessageNotice'], resolve),
		// 	meta:{
		// 		requiresAuth: true
        //     },
        // },
        // 作品详情页手机版
        {
            path: '/works/m/:id',
            name: 'WorksMobile',
            component: (resolve) => require(['@/views/works/MobileDetail'],resolve),
            meta: {
                // requiresAuth: true
            }
        },
        //帮助中心
        {
            path: '/help_center',
            name: 'HelpCenter',
            component:(resolve)=> require(['@/views/helpCenter/HelpCenter'], resolve),
            meta:{
                requiresAuth: true
            },
        },
        // 小班教室

	]
});

if (window.localStorage.getItem('jwt')) {
}

if (window.localStorage.getItem('permission')) {

}

if (window.localStorage.getItem('currentUser')) {

}
//const baseUrl = process.env.LOGIN_HOST + (process.env.PORT == '8080'?'': ":"+ process.env.PORT);
// const protocal = process.env.PROTOCOL +"://";

router.beforeEach((to, from, next) => {
    if(to.matched.length === 0){ // 当地址错误无法匹配时跳转到首页
        from.name ? next({name: from.name}) : next('/');
    } else {
        next();
    }
    if(to.meta.title){
        console.log('title');
        document.title = to.meta.title;
    } else {
        console.log('no title');
        document.title = '上课系统-个人中心';
    }
	if(to.matched.some(r=>r.meta.requiresAuth)){
		if(store.state.currentUser && store.state.currentUser.id){
			next();
		}else{
            console.log('before getuserinfo');
			GetUserInfo().then(response=>{
				let userInfo = response.data;
				store.commit(CURRENTUSER, userInfo);
				localStorage.setItem('currentUser', JSON.stringify(userInfo));
			}).catch(error=>{
                // MessageBox.alert('授权码过期，请重新登录', '未授权', {
                //     confirmButtonClass: '登录',
                //     callback: action => {
                //         localStorage.clear();
                //         let url = location.href;
                //         let res = encodeURI(url);
				//         window.location.href = protocal +process.env.LOGIN_HOST+'/login?redirect_uri='+res;
                //     }
                // });

			});
		}
	}else{
		next();
	}
	next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js